"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JUSTIFICATION_MIN_WORDS = exports.JUSTIFICATION_MIN_LETTERS = void 0;
exports.validateRequestJustification = validateRequestJustification;
/** Minimum letters a justification must keep once filler and emoticons are removed */
exports.JUSTIFICATION_MIN_LETTERS = 8;
/** Minimum words (of 2+ letters) a justification must keep once filler and emoticons are removed */
exports.JUSTIFICATION_MIN_WORDS = 2;
/**
 * Words that carry no reason: laughter, apologies-as-filler and pleading. They are
 * removed before counting, so "jeje upsi" or "por favorcito" count as empty.
 */
const FILLER_WORDS = new Set([
    'ja', 'jaja', 'jajaja', 'je', 'jeje', 'jejeje', 'ji', 'jiji', 'jijiji', 'jsjs', 'jsjsjs',
    'xd', 'xdd', 'lol', 'ups', 'upsi', 'oops', 'uwu', 'owo', 'u', 'uu',
    'porfa', 'porfis', 'porfavor', 'favor', 'favorcito',
]);
/** Emoticons written with punctuation: u.u, :(, :c, :), ;), :p, xD… */
const EMOTICONS = /(?:\bu[._]u\b|[:;=][-']?[()cpPdDsS3oO/\\|]+|<3)/g;
/**
 * Checks that a request (time off, attendance correction) carries a real reason and not
 * filler. Rejects empty text, emojis and emoticons alone, laughter ("jiji", "jeje upsi"),
 * single words ("personal", "tráfico") and bare times ("6:45").
 *
 * It does not judge whether the reason is good enough — only that there is one.
 */
function validateRequestJustification(text) {
    const cleaned = (text ?? '')
        .toLowerCase()
        .replace(EMOTICONS, ' ')
        // Keep letters (any alphabet, accents included) and spaces; drop digits, emoji, punctuation
        .replace(/[^\p{L}\s]/gu, ' ');
    const words = cleaned
        .split(/\s+/)
        .filter((word) => word.length >= 2 && !FILLER_WORDS.has(word) && !/^(?:ja|je|ji|js)+$/.test(word));
    const letters = words.join('').length;
    if (words.length < exports.JUSTIFICATION_MIN_WORDS || letters < exports.JUSTIFICATION_MIN_LETTERS) {
        return {
            isValid: false,
            error: 'Explica el motivo con al menos dos palabras (por ejemplo: «cita en el IMSS a las 11»). ' +
                'No cuentan emojis, risas ni «porfa».',
        };
    }
    return { isValid: true };
}
